import { render, staticRenderFns } from "./prizesDeployTimeSet.vue?vue&type=template&id=0bd3f88a&scoped=true"
import script from "./prizesDeployTimeSet.vue?vue&type=script&lang=js"
export * from "./prizesDeployTimeSet.vue?vue&type=script&lang=js"
import style0 from "./prizesDeployTimeSet.vue?vue&type=style&index=0&id=0bd3f88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd3f88a",
  null
  
)

export default component.exports